import React from 'react';
import { IDropzoneProps, Dropzone} from './Dropzone'
import { Errors, IErrorProps } from './Errors'
import { Grid } from 'semantic-ui-react';

interface IUploadAndErrors extends IDropzoneProps,IErrorProps {}

export const UploadAndErrors =({
  inputFiles = [],
  onChange,
  uploadButtonCaption,
  cancelButtonCaption,
  handleUpload,
  handleReset,
  dimmerText,
  errorResult
}:IUploadAndErrors) => {
  return <Grid>
    <Grid.Row>
      <Grid.Column width="16">
        <Dropzone inputFiles={inputFiles} onChange={onChange} uploadButtonCaption={uploadButtonCaption} cancelButtonCaption={cancelButtonCaption} handleUpload={handleUpload} handleReset={handleReset} dimmerText={dimmerText} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width="16">
        <Errors errorResult={errorResult}/>
      </Grid.Column>
    </Grid.Row>
    
  </Grid>
}